import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "@/components/Icon";
import { useLead } from "@/context/LeadContext";

const PILLARS = [
  { icon: "Cpu", title: "Artificial Intelligence", text: "Predictive models and intelligent automation that reduce burden and improve outcomes." },
  { icon: "Cloud", title: "Cloud Infrastructure", text: "HIPAA-ready, elastic cloud built for healthcare scale, reliability and uptime." },
  { icon: "Share2", title: "Interoperability", text: "FHIR / HL7 standards-based connectivity that unites systems, devices and partners." },
  { icon: "Database", title: "Unified Data Platform", text: "One connected data foundation turning information into actionable insight." },
  { icon: "Lock", title: "Security & Compliance", text: "Zero-trust security and enterprise-grade protection for patients and data." },
  { icon: "Workflow", title: "Automation & Integration", text: "Streamlined workflows connecting people, systems and care across the ecosystem." },
];

const STACK = [
  "FHIR & HL7 standards-based integration",
  "AI-driven predictive analytics",
  "Real-time connected device data",
  "Zero-trust cybersecurity architecture",
  "Scalable, resilient cloud operations",
  "Unified EHR / EMR across divisions",
];

export default function TechnologyPage() {
  const { openLead } = useLead();
  const navigate = useNavigate();
  useEffect(() => { document.title = "Technology | Proactive UMS Corporate"; window.scrollTo(0, 0); }, []);

  return (
    <div className="ip" data-testid="technology-page">
      <section className="dp-hero ip-hero">
        <div className="dp-hero__bg" style={{ backgroundImage: "url(/assets/hero-slide-4.png)" }} />
        <div className="dp-hero__veil" />
        <div className="container">
          <div className="dp-hero__inner">
            <span className="eyebrow">Technology at Proactive UMS</span>
            <h1 className="dp-hero__title display">Intelligence That Powers Care</h1>
            <p className="dp-hero__tagline">AI, cloud and data — the backbone of the ecosystem.</p>
            <p className="dp-hero__blurb">Our platform unites artificial intelligence, secure cloud infrastructure and standards-based interoperability so every division delivers smarter, safer, more connected care.</p>
            <div className="dp-hero__actions">
              <button className="btn btn--green" onClick={() => openLead("demo")} data-testid="tech-demo">Request a Demo <Icon name="ArrowRight" size={16} /></button>
              <button className="btn btn--outline-dark" onClick={() => navigate("/division/core")} data-testid="tech-core">Explore ProactiveCore+</button>
            </div>
          </div>
        </div>
      </section>

      <section className="dp-services">
        <div className="container">
          <div className="sec-head">
            <div className="sec-head__left">
              <h2 className="sec-head__title">Technology Pillars<span className="sec-head__rule" /></h2>
              <p className="sec-head__sub">The connected foundation behind every division.</p>
            </div>
          </div>
          <div className="dp-services__grid">
            {PILLARS.map((s) => (
              <div className="dp-service" key={s.title} data-testid={`tech-pillar-${s.title}`}>
                <span className="dp-service__ic"><Icon name={s.icon} size={24} /></span>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ip-story">
        <div className="container ip-story__grid">
          <div className="sec-head sec-head--stack"><h2 className="sec-head__title">Built on Open Standards<span className="sec-head__rule" /></h2></div>
          <div className="ip-story__body">
            <ul className="tech-stack">
              {STACK.map((s) => (<li key={s}><Icon name="CheckCircle2" size={18} /> <span>{s}</span></li>))}
            </ul>
          </div>
        </div>
      </section>

      <section className="dp-cta">
        <img src="/assets/cta-family.png" className="dp-cta__bg" alt="" />
        <div className="container dp-cta__inner">
          <div className="dp-cta__copy">
            <h2 className="dp-cta__title display">See the platform in action.</h2>
            <p>Discover how PUMS technology connects your organization.</p>
          </div>
          <div className="dp-cta__actions">
            <button className="btn btn--green" onClick={() => openLead("demo")}>Request a Demo <Icon name="ArrowRight" size={16} /></button>
            <button className="btn btn--outline-dark" onClick={() => navigate("/contact")}><Icon name="Mail" size={16} /> Contact Our Team</button>
          </div>
        </div>
      </section>
    </div>
  );
}
